module.exports = __webpack_public_path__ + "components/weather-icon/static/nightheavyrain-ab5f792120606f3812e1ce7286e0dc7d.webp";